<script setup>
import { TablePagination } from "@easy/ui/tables";
import { t } from "@/i18n";
import { computed } from "vue";

defineProps({
    totalPages: {
        type: Number,
        required: true,
    },
});

const currentPage = defineModel({ required: true });

const paginationTexts = computed(() => ({
    previous: t("shared.pagination.previous"),
    next: t("shared.pagination.next"),
    page: t("shared.pagination.page"),
    of: t("shared.pagination.of"),
}));
</script>

<template>
    <TablePagination
        v-if="totalPages > 1"
        v-model="currentPage"
        :max-value="totalPages"
        :texts="paginationTexts"
        class="px-5 sm:px-0"
    />
</template>
